// ===== LocalStorage-based Cart Utility Functions =====

// Get cart data from localStorage
function getCartData() {
    try {
        return JSON.parse(localStorage.getItem('tuote_cart') || '{}');
    } catch (e) {
        return {};
    }
}

// Save cart data to localStorage
function setCartData(cart) {
    localStorage.setItem('tuote_cart', JSON.stringify(cart));
}

function formatNumberWithSpaces(num) {
    const number = Number(num);
    const isWhole = Number.isInteger(number);
    const [integer, decimal] = number.toFixed(2).split('.');
    const formattedInt = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    return isWhole ? formattedInt : `${formattedInt}.${decimal}`;
}

function deleteProductFromCart(productId) {
    let cart = getCartData();
    if (cart[productId]) {
        delete cart[productId];
        setCartData(cart);
    }
}

function updateProduct(productId, productName, productLink, productPrice, productCode) {
    let cart = getCartData();
    if (!cart[productId]) {
        cart[productId] = { name: productName, link: productLink, price: productPrice, code: productCode, count: 0 };
    }
    cart[productId].count += 1;
    setCartData(cart);
}

function updateCountInCart(productId, newCount) {
    let cart = getCartData();
    if (cart[productId]) {
        cart[productId].count = newCount;
        setCartData(cart);
    }
}

function countAllProducts() {
    let cart = getCartData();
    let totalCount = 0;
    const linkDivCount = document.querySelector('.ostoskorilinkki__count');

    for (let productId in cart) {
        if (cart.hasOwnProperty(productId)) {
            totalCount += cart[productId].count;
        }
    }

    if (linkDivCount && totalCount > 0) {
        linkDivCount.innerHTML = '(' + totalCount + ')';
    } else if (linkDivCount) {
        linkDivCount.innerHTML = '';
    }
}

function calculateTotalPrice() {
    let cart = getCartData();
    let totalPrice = 0;

    for (let productId in cart) {
        if (cart.hasOwnProperty(productId)) {
            let product = cart[productId];
            let price = parseFloat(String(product.price).replace(',', '.'));
            let count = parseInt(product.count, 10);

            if (!isNaN(price) && !isNaN(count)) {
                totalPrice += price * count;
            }
        }
    }

    return totalPrice;
}

function addTotalPrice() {
    const linkDivTotalPrice = document.querySelector('.ostoskorilinkki__totalprice');
    const totalPrice = calculateTotalPrice();

    if (linkDivTotalPrice && totalPrice > 0) {
        linkDivTotalPrice.innerHTML = formatNumberWithSpaces(totalPrice) + ' €';
    } else if (linkDivTotalPrice) {
        linkDivTotalPrice.innerHTML = '';
    }
}

function checkAndToggleLinkVisibility() {
    let cart = getCartData();
    const linkDiv = document.querySelector('.ostoskorilinkki');
    const body = document.body;

    if (linkDiv) {
        if (Object.keys(cart).length > 0) {
            linkDiv.classList.remove('hidden');
            linkDiv.classList.add('show');
            body.classList.add('has-cart-items');
            body.classList.remove('no-cart-items');
        } else {
            linkDiv.classList.remove('show');
            linkDiv.classList.add('hidden');
            body.classList.remove('has-cart-items');
            body.classList.add('no-cart-items');
        }
    }
}

function checkAndAddClass() {
    let tuotteetData = getCartData();

    let tuotteetContainer = document.querySelector('.tuotteet');
    if (!tuotteetContainer) return;

    document.querySelectorAll('.tuote').forEach(tuote => {
        let tuoteId = tuote.getAttribute('tuoteid');
        if (tuoteId && tuotteetData[tuoteId]) {
            tuote.classList.add('added');
        }
    });
}

function renderProducts() {
    const container = document.querySelector('.tilauslomaketuotteet');

    if (container) {
        container.innerHTML = '';

        let cart = getCartData();

        for (let productId in cart) {
            if (cart.hasOwnProperty(productId)) {
                const { name, link, price, code, count } = cart[productId];
                const formatedprice = formatNumberWithSpaces(price);
                const productDiv = document.createElement('div');
                productDiv.className = 'tilauslomaketuote';
                productDiv.setAttribute('data-price', price);

                productDiv.innerHTML = `
                    <div class="tilauslomaketuote__vasen">
                        <a href="${link}">${name}</a>
                        <p class="price">${formatedprice} €</p>
                    </div>
                    <div class="tilauslomaketuote__oikea">
                        <label>Määrä: <input type="number" class="product-count" value="${count}" min="1" data-tuote-id="${productId}" /></label>
                        <button class="remove-product" data-tuote-id="${productId}">Poista</button>
                    </div>
                `;

                container.appendChild(productDiv);
            }
        }

        container.querySelectorAll('.product-count').forEach(input => {
            input.addEventListener('change', function () {
                let newCount = parseInt(input.value, 10);
                const productId = input.getAttribute('data-tuote-id');

                if (isNaN(newCount) || newCount < 1) {
                    newCount = 1;
                    input.value = 1;
                }

                updateCountInCart(productId, newCount);
                countAllProducts();
                addTotalPrice();
                updateTotalPrice();
                updateTextareaWithProducts();
            });
        });

        container.querySelectorAll('.remove-product').forEach(button => {
            button.addEventListener('click', function () {
                const productId = button.getAttribute('data-tuote-id');
                deleteProductFromCart(productId);
                renderProducts();
                countAllProducts();
                addTotalPrice();
                updateTotalPrice();
                checkAndToggleLinkVisibility();
                updateTextareaWithProducts();

                let tuotteetContainer = document.querySelector('.tuotteet');
                if (tuotteetContainer) {
                    let tuoteElement = tuotteetContainer.querySelector(`.tuote[tuoteid="${productId}"]`);
                    if (tuoteElement) {
                        tuoteElement.classList.remove('added');
                    }
                }
            });
        });

        updateTextareaWithProducts();
    }

    countAllProducts();
    addTotalPrice();
    updateTotalPrice();
    checkAndToggleLinkVisibility();
}

function updateTotalPrice() {
    const totalPriceContainer = document.querySelector('.tilauslomaketotalprice__count');
    const totalPrice = calculateTotalPrice();
    if (totalPriceContainer) {
        totalPriceContainer.innerHTML = '';
        totalPriceContainer.innerHTML = formatNumberWithSpaces(totalPrice) + ' €';
    }
}

function updateTextareaWithProducts() {
    const container = document.querySelector('.tilauslomaketuotteet');
    const textarea = document.querySelector('form .tuotteetkentta textarea');

    if (!container || !textarea) {
        return;
    }

    let cart = getCartData();
    let productList = [];

    for (let productId in cart) {
        if (cart.hasOwnProperty(productId)) {
            const { name, count, price, link, code } = cart[productId];
            const formatedprice = formatNumberWithSpaces(price);

            productList.push(`Tuote: ${name}\nTuotekoodi: ${code}\nHinta: ${formatedprice} €\nMäärä: ${count} kpl\nTuotelinkki: ${link}`);
        }
    }

    textarea.value = productList.join('\n\n');

    const totalPrice = calculateTotalPrice();
    const textareaTotalPrice = '\n\nYhteensä: ' + formatNumberWithSpaces(totalPrice) + ' €';
    textarea.value += textareaTotalPrice;
}

// ===== Event Listeners =====

document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', function (e) {
        const button = e.target.closest('.lisaaostoskoriin');
        if (button) {
            let productId = button.getAttribute('data-tuote-id');
            let productName = button.getAttribute('data-tuote-name');
            let productLink = button.getAttribute('data-tuote-link');
            let productPrice = button.getAttribute('data-tuote-hinta');
            let productCode = button.getAttribute('data-tuote-code');

            if (productId && productName && productLink && productPrice && productCode) {
                updateProduct(productId, productName, productLink, productPrice, productCode);
                renderProducts();
            }

            if (!button.classList.contains('singletarjouspyynto')) {
                let closestTuote = button.closest('.tuote');
                if (closestTuote) {
                    closestTuote.classList.add('added');
                }
            }

            button.blur();
        }
    });

    checkAndAddClass();
    renderProducts();
});

document.addEventListener('DOMContentLoaded', function () {
    jQuery(document).on('gform_confirmation_loaded', function (event, formId) {
        if (formId == 2) {
            localStorage.removeItem('tuote_cart');
            //renderProducts();

            const style = document.createElement('style');
            style.textContent = `
                .ostoskorilinkki, .remove-product {
                    display:none!important;
                }
            `;
            document.head.appendChild(style);

            document.querySelectorAll('input.product-count').forEach(input => {
                input.disabled = true;
            });
        }
    });
});
